import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	weChatLabel: 'js-m-contact-teaser-card__weChat-label',
	weChatQRBox: 'js-m-contact-teaser-card__weChat-qr-box',
	stateQRShow: 'state-m-contact-teaser-card__weChat-qr-box--active'
};

@createModule('ContactTeaserCard')
/**
 * @author 
 */

export class ContactTeaserCard extends TerrificSpec {
	$ctx: JQuery;
	$weChatLabel: JQuery;
	$weChatQRBox: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$weChatLabel = $(`.${classes.weChatLabel}`, this.$ctx);
		this.$weChatQRBox = $(`.${classes.weChatQRBox}`, this.$ctx);

		$('html').on('click', () => {
			this.hideQRCode();
		})

		this.$weChatLabel.on('click',this.openQRCode.bind(this));

		resolve();
	}
	stop() {}

	hideQRCode() {
		this.$weChatQRBox.removeClass(classes.stateQRShow);
	}
	
	openQRCode(ev:Event) { 
		ev.stopPropagation();
		this.$weChatQRBox.toggleClass(classes.stateQRShow); 
	}
 
}
